export const cardFormFactorOptionId = 704;
export const cardFormFactorOptionValueIds = {
  plastic: 100882,
  virtual: 100883,
};
